/*
Copyright© Celligence International, LLC - 2026

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import EnvelopeWithBox from '../EnvelopeWithBox';
import Styles from '../../css/LoanInformation.module.css';
import { useLoanInformationContext } from '../../contexts/LoanInformationContext';
import {
  convertDateInputTo8AMLocal,
  dateToEpoch,
  formatDateForInputWithOffset,
  formatEIN,
} from '../../common/UtilityFunctions';

const EntityInfo = () => {
  const { propData } = useLoanInformationContext();

  return (
    <EnvelopeWithBox blockName='Entity Information'>
      <div className={Styles.loanInfoTable}>
        <div className={Styles.leftColumn}>
          <table className={Styles.loanInfoTableSection}>
            <tbody>
              <tr>
                <th>Entity Name:</th>
                <td>
                  <input type='text' value={propData?.entityName ?? ''} readOnly />
                </td>
              </tr>

              <tr>
                <th>EIN Number:</th>
                <td>
                  <input type='text' value={formatEIN(propData?.entityTaxId ?? '')} readOnly />
                </td>
              </tr>

              <tr>
                <th>Date of Establishment</th>
                <td>
                  <input
                    type='date'
                    className={Styles.calIcon}
                    value={
                      propData?.entityDateOfEstablishment
                        ? formatDateForInputWithOffset(propData.entityDateOfEstablishment)
                        : ''
                    }
                    readOnly
                  />
                </td>
              </tr>
            </tbody>
            <tr>
              <td colSpan={2} className={Styles.bottomRowSpacer}></td>
            </tr>
          </table>
        </div>
      </div>
    </EnvelopeWithBox>
  );
};

export default EntityInfo;
